import _URL from '../../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        updatePrifile: (user_id, role, account_type, body, token) => {
            if (role === account_type) {
                if (role === "admin") {
                    return axios(token).patch(`/customers/${user_id}/profile`, body);
                } else if (role === "company") {
                    return axios(token).patch(`/profile/companies/${user_id}`, body);
                } else {
                    return axios(token).patch(`/operators/${user_id}/profile`, body);
                }
            } else {
                return axios(token).patch(`/profile/users/${user_id}`, body);
            }
        },
        getProfileUser: (userid, role, type, token) => {
            return role === type ? axios(token).get(`/operators/${userid}`) : axios(token).get(`/users/${userid}`);

        },
        getOperatorById: (userid, token) => {
            return  axios(token).get(`/operators/${userid}`);

        },
        updateAnyAttributeById: (operatorId, operator,  token = "") => {
            return axios(token).patch(`/operators/${operatorId}`, operator);
        },
    }
}